function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.3mm",
    height: "8.3000002mm",
    viewBox: "0 0 3.3 8.3000002",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.8564502,-2.7413357)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 4.5064502,
    cy: 6.891336,
    rx: 1.25,
    ry: 3.7500002
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainVertical);
export default __webpack_public_path__ + "static/media/chain-vertical.6de3482a2f4dc4060581b31c81a9298e.svg";
export { ForwardRef as ReactComponent };